export default {
  functional: true,
  name: "DsfDataGridSelection",
  props: {
    isAllSelected: {
      type: Boolean,
      default: false
    }
  },
  render(h, vm){
    return (<el-table-column
      props={vm.data.attrs}
      type=""
      scopedSlots={{
        header: scope => renderHeader(h, vm, scope),
        default: scope => renderDefault(h, vm, scope),
      }}
      hook={{
        init(vNode) {
          let columnVm = vNode.componentInstance;
          let store = columnVm.owner.store;
          store.states.selectable = columnVm.selectable || null;
          store.states.reserveSelection = columnVm.reserveSelection || false;
          dsf.setObjAttr(store, '$isAllSelected', Vue.observable({
            value: vm.props.isAllSelected
          }));
        },
        update(oldVnode, vNode) {
          let columnVm = vNode.componentInstance;
          let store = columnVm.owner.store;
          store.$isAllSelected.value = vm.props.isAllSelected
        },
        destroy(vNode) {
          let columnVm = vNode.componentInstance;
          let store = columnVm.owner.store;
          delete store.$isAllSelected
        }
      }}
    />);
  },
}

function renderHeader(h, vm, {store}){
  return (<el-popover
    placement="right"
    trigger="hover"
    popper-class="ds-datagrid-isallselected-popover"
    scopedSlots={{
      reference() {
        return <div class={['el-checkbox', {'is-checked': store.states.isAllSelected}]} on={{
          click: () => {
            if (store.$isAllSelected.value) {
              $emit(vm, 'update:is-all-selected', false);
            } else {
              store.toggleAllSelection();
            }
          }
        }}>
          <span class={['el-checkbox__input', {
            'is-indeterminate': store.states.selection.length > 0 && !store.states.isAllSelected,
            'is-checked': store.$isAllSelected.value || store.states.isAllSelected
          }]}>
            <span class="el-checkbox__inner" />
          </span>
        </div>
      }
    }}>
    <el-row>
      <el-col span={24}>
        <el-checkbox
          name=""
          disabled={store.$isAllSelected.value || (store.states.data && store.states.data.length === 0)}
          indeterminate={store.states.selection.length > 0 && !store.states.isAllSelected}
          value={store.$isAllSelected.value || store.states.isAllSelected}
          onNative={{
            click: e => e.stopPropagation()
          }}
          on={{
            input: () => store.toggleAllSelection()
          }}
        >
          当前页
        </el-checkbox>
      </el-col>
      {/* <el-col span={15}><label for="">当前页</label></el-col> */}
    </el-row>
    <el-row>
      <el-col span={24}>
        <el-checkbox
          disabled={store.states.data && store.states.data.length === 0}
          value={store.$isAllSelected.value }
          onNative={{
            click: e => e.stopPropagation()
          }}
          on={{
            input: e => {
              e || store.clearSelection();
              $emit(vm, 'update:is-all-selected', e);
            }
          }}
        >全部页</el-checkbox>
      </el-col>
      {/* <el-col span={15}>全部页</el-col> */}
    </el-row>
  </el-popover>);
}

function renderDefault(h, vm, { row, column, store, $index }) {
  return (<el-checkbox
    value={store.$isAllSelected.value || store.isSelected(row)}
    disabled={store.$isAllSelected.value || (column.selectable ? !column.selectable.call(null, row, $index) : false)}
    onNative={{
      click: e => e.stopPropagation()
    }}
    on={{
      input: e => store.commit('rowSelectedChanged', row)
    }}
  />);
}

function $emit(vm, eventName, ...args) {
  let fn = vm.listeners[eventName];
  if (dsf.type(fn) == 'function') {
    fn = [fn];
  }
  if (dsf.type(fn) == 'array') {
    _.each(fn, f => dsf.type(f) && f(...args));
  }
}